import React from 'react';
import { Grid, Button, TextField, Autocomplete } from '@mui/material';

export const SolicitorSelection = ({
  solicitorList,
  selectedSolicitor,
  setSelectedSolicitor,
  getName,
  isApproved,
  matchessm,
  setOpenAddSolicitor,
}) => {
  return (
    <Grid
      container
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '20px',
      }}
    >
      <Grid item xs={12} sm={9}>
        <Autocomplete
          options={solicitorList}
          value={selectedSolicitor}
          id="combo-box-demosd"
          disableClearable={true}
          onChange={(e, val) => setSelectedSolicitor(val)}
          getOptionLabel={(o) => getName(o)}
          getOptionDisabled={(o) => !isApproved(o)}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select Solicitor"
              InputLabelProps={{
                style: {
                  fontFamily: 'poppins',
                  fontSize: '14px',
                  background: 'white',
                  padding: '0 5px',
                },
              }}
            />
          )}
          sx={{
            fontFamily: 'poppins',
            '& .MuiAutocomplete-inputRoot': { fontFamily: 'poppins' },
            '& .MuiAutocomplete-option': {
              '&:disabled': {
                opacity: 1,
                pointerEvents: 'none',
                '& span:last-child': {
                  color: 'inherit',
                },
              },
            },
          }}
          renderOption={(props, option) => (
            <li
              {...props}
              style={{
                fontSize: matchessm ? '12px' : '14px',
                padding: matchessm ? ' 4px 10px' : '10px',
                color: option.isLinked == 0 ? 'gray' : 'black',
                cursor: option.isLinked == 0 ? 'not-allowed' : 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                minHeight: matchessm ? '15px' : '',
                opacity: option.isLinked == 0 ? 1 : undefined,
              }}
            >
              <span>{getName(option)}</span>
              <span
                style={{
                  color:
                    option.isLinkedStatus == 'Pending'
                      ? 'orange'
                      : option.isLinkedStatus == 'Approved'
                      ? 'green'
                      : 'red',
                  fontSize: matchessm ? '12px' : '14px',
                }}
              >
                {option.isLinkedStatus}
              </span>
            </li>
          )}
        />
      </Grid>
      <Grid item xs={12} sm={2.5}>
        <Button
          color="primary"
          sx={{
            fontSize: matchessm ? '12px' : '16px',
            fontFamily: 'Poppins',
            fontWeight: '400',
            textTransform: 'none',
            border: 'none !important',
            padding: !matchessm && '5px',
            whiteSpace: 'nowrap',
          }}
          onClick={() => {
            setOpenAddSolicitor(true);
          }}
        >
          + Add New
        </Button>
      </Grid>
    </Grid>
  );
};
